import classNames from 'classnames';
import React, { MouseEvent, ReactElement } from 'react';
import Icon from '../../icon/icon';
import './chips.scss';

const Chips: React.FC<{
    className?: string;
    onClick?: (e: MouseEvent<HTMLButtonElement | HTMLAnchorElement>) => void;
    children: React.ReactNode;
}> = ({
    className,
    children,
    onClick
}): ReactElement => (
    <span
        className={classNames({
            [className || '']: className,
            chips: true
        })}
    >
        {children}
        <Icon className="remove" name="x" color="primary"
            size={14} onClick={onClick}
        />
    </span>
);

export default Chips;
